import React from 'react';
import './Choosemold.css';
import img1 from '../../../imgs/Chooseinject.webp';
import img2 from '../../../imgs/Cavitiespref.webp';
import img3 from '../../../imgs/Commonpre.webp';

const cards = [
  {
    img: img1,
    category: '#Knowledge',
    title: 'How To Choose PET Preform Injection Molding Machine',
    date: 'Jul 13, 2022',
    action: 'Read Blog'
  },
  {
    img: img2,
    category: '#Mould Testing',
    title: '64 Cavities PET preform Mould Testing with KPET2100-E6',
    date: 'Jul 11, 2022',
    action: 'Watch Video'
  },
  {
    img: img3,
    category: '#Knowledge',
    title: 'The Common Types of PET Preforms',
    date: 'Jul 13, 2022',
    action: 'Read Blog'
  }
];

const Choosemold = () => {
  return (
    <div className="choosemold-wrapper">
      <h2 className="choosemold-heading">What's New</h2>
      <div className="choosemold-cards">
        {cards.map((item, index) => (
          <div className="choosemold-card" data-aos="fade-down" key={index}>
            <img src={item.img} alt={item.title} className="choosemold-img" />
            <div className="choosemold-content">
              <p className="choosemold-category">{item.category}</p>
              <h3 className="choosemold-title">{item.title}</h3>
              <div className="choosemold-footer">
                <span>{item.date}</span>
                <p>{item.action}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Choosemold;
